import { render } from "./ReactionBar.vue?vue&type=template&id=57cde7e0&scoped=true"
import script from "./ReactionBar.vue?vue&type=script&lang=js"
export * from "./ReactionBar.vue?vue&type=script&lang=js"

import "./ReactionBar.vue?vue&type=style&index=0&id=57cde7e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cde7e0"]])

export default __exports__